import { connect } from 'react-redux'

import DataSourceMigrationStatusView from './view.jsx';
import {
  invalidateMigrationStatus, 
  fetchDataSource} from 'src/redux/actions/dataSource.ts';

const mapStateToProps = (state,ownProps) => {
  var id = ownProps.datasource.id;
  var status = state.dataSource.migrationProgress.find((item) => {
    return item.id = id;
  });

  return {
    status: status
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    invalidateMigrationStatus: (id) => {
      dispatch(invalidateMigrationStatus(id));
    },

    fetchDataSource: (metadata) => {
      return dispatch(fetchDataSource(metadata));
    }
  }
}

const DataSourceMigrationStatusContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DataSourceMigrationStatusView)

export default DataSourceMigrationStatusContainer;